import { createSlice } from '@reduxjs/toolkit';
import initialState from './2284InitialState';
import {
  _setNew2284Form,
  _setEpdIrId,
  _setReportingProgram,
  _setParoleAgentOfRecord,
  _setIncidentLocation,
  _setIncidentDate,
  _setOrgAddress,
  _setAdmitDate,
  _setIncidentAddress,
  _setIncidentTime,
  _setCaseManagerName,
  _setCaseManagerTelephone,
  _setCaseManagerEmail,
  _setDapo,
  _setDhcs,
  _setDrp,
  _setOther,
  _setOtherDescription,
  _setIsContactedFire,
  _setIsContactedParamedics,
  _setIsContactedPolice,
  _setContactedAgenciesName,
  _setIsParoleArrested,
  _setArrestingAgency,
  _setArrestDate,
  _setIsNewsMediaCoverage,
  _setNewsAgency,
  _setNewsRepNameAndPhone,
  _setIsLawEnforcementContacted,
  _setLawEnforcementAgency,
  _setIncidentDescription,
  _setIncidentCreateDate,
  _setIncidentCreatedBy,
} from './2284Actions';

export const slice2284 = createSlice({
  name: 'get2284Form',
  initialState,
  reducers: {
    get2284Form: (state, action) => action.payload,
    setNew2284Form: _setNew2284Form,
    setEpdIrId: _setEpdIrId,
    setReportingProgram: _setReportingProgram,
    setParoleAgentOfRecord: _setParoleAgentOfRecord,
    setIncidentLocation: _setIncidentLocation,
    setIncidentDate: _setIncidentDate,
    setOrgAddress: _setOrgAddress,
    setAdmitDate: _setAdmitDate,
    setIncidentAddress: _setIncidentAddress,
    setIncidentTime: _setIncidentTime,
    setCaseManagerName: _setCaseManagerName,
    setCaseManagerTelephone: _setCaseManagerTelephone,
    setCaseManagerEmail: _setCaseManagerEmail,
    setDapo: _setDapo,
    setDhcs: _setDhcs,
    setDrp: _setDrp,
    setOther: _setOther,
    setOtherDescription: _setOtherDescription,
    setIsContactedFire: _setIsContactedFire,
    setIsContactedParamedics: _setIsContactedParamedics,
    setIsContactedPolice: _setIsContactedPolice,
    setContactedAgenciesName: _setContactedAgenciesName,
    setIsParoleArrested: _setIsParoleArrested,
    setArrestingAgency: _setArrestingAgency,
    setArrestDate: _setArrestDate,
    setIsNewsMediaCoverage: _setIsNewsMediaCoverage,
    setNewsAgency: _setNewsAgency,
    setNewsRepNameAndPhone: _setNewsRepNameAndPhone,
    setIsLawEnforcementContacted: _setIsLawEnforcementContacted,
    setLawEnforcementAgency: _setLawEnforcementAgency,
    setIncidentDescription: _setIncidentDescription,
    setIncidentCreateDate: _setIncidentCreateDate,
    setIncidentCreatedBy: _setIncidentCreatedBy,
    reset2284Form: () => initialState,
  },
});

export const {
  get2284Form,
  setNew2284Form,
  setEpdIrId,
  setReportingProgram,
  setParoleAgentOfRecord,
  setIncidentLocation,
  setIncidentDate,
  setOrgAddress,
  setAdmitDate,
  setIncidentAddress,
  setIncidentTime,
  setCaseManagerName,
  setCaseManagerTelephone,
  setCaseManagerEmail,
  setDapo,
  setDhcs,
  setDrp,
  setOther,
  setOtherDescription,
  setIsContactedFire,
  setIsContactedParamedics,
  setIsContactedPolice,
  setContactedAgenciesName,
  setIsParoleArrested,
  setArrestingAgency,
  setArrestDate,
  setIsNewsMediaCoverage,
  setNewsAgency,
  setNewsRepNameAndPhone,
  setIsLawEnforcementContacted,
  setLawEnforcementAgency,
  setIncidentDescription,
  setIncidentCreateDate,
  setIncidentCreatedBy,
  reset2284Form,
} = slice2284.actions;

export default slice2284.reducer;
